export default __webpack_public_path__ + "static/media/chip_5.a16c4830.svg";